export default function (stateAuth) {
  const currentTimestamp = Math.floor(Date.now() / 1000);

  if (stateAuth.accessToken && stateAuth.accessTokenSetAt - currentTimestamp < stateAuth.accessTokenValidUntil) {
    return true;
  }

  return false;
}
